import * as React from "react";
import styles from "./FormField.module.css";

interface FormFieldProps {
  label: string;
  optional?: boolean;
  hint?: string;
  error?: string;
  errorIcon?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({ label, optional, hint, error, errorIcon, children, className }) => (
  <div className={[styles.field, className].filter(Boolean).join(" ")}>
    <label className={styles.label}>
      {label}
      {optional && <span className={styles.labelHint}> при наличии</span>}
      {hint && <span className={styles.labelHint}> {hint}</span>}
    </label>
    {children}
    {error && (
      <span className={styles.errorMsg}>
        {errorIcon && <i className={`fa-solid fa-circle-exclamation ${styles.errorIcon}`} />}
        {error}
      </span>
    )}
  </div>
);
